module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/11-1b29c2cd966d595914d146d402cc97ef.jpg";